import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "clock-rewind-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5 },
        React.createElement("path", { d: "M13.211 3.838A8.26 8.26 0 0 0 12 3.75a8.25 8.25 0 1 0 6.044 2.635" }),
        React.createElement("path", { strokeLinejoin: "round", d: "M11.75 7.75v3.805a1 1 0 0 0 .331.743l2.169 1.952h0m3-5v-3.5h3.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
